/* AuditPolicyGridViewComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
//const UserGridData = require('@gluenetworks/entity_grid_gl').UserData;
const Renderer = require("./AuditPolicyGridViewRenderer");
const Registrations = require("../../../../../RegistrationNamespaces");

const DateColumn = require("./column_renderers/date/DateComponent");
const AuditStatusColumn = require("./column_renderers/audit_status/AuditStatusComponent");
const PermissionLevelColumn = require("./column_renderers/permission_level/PermissionLevelComponent");

const PagingAuditFeed = require("./PagingAuditFeed");
const {AUDIT_STATUSES, PERMISSION_LEVEL} = require("./AuditPolicyConstants");

const _ = require("lodash");

class AuditPolicyGridViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        steveUtils,
        ConfigAuditPolicy,
        userSession,
        storageFactory,
        solutionsManager,
        modalUserFeedback
    ) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._steveUtils = steveUtils;
        this._userSession = userSession;
        this._modalUserFeedback = modalUserFeedback;
        this._solutionsManager = solutionsManager;
        this._solutionName =
            (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "auditExplorer";
        this._storageFactory = storageFactory;
        this._userGridData = undefined;
        this._configAuditPolicy = ConfigAuditPolicy;
        this._pagingAuditFeed = undefined;
        this._renderer = new Renderer(this);
        this._explorerState = {
            selectedIds: [],
        };
        this.columns = undefined;
        this._sessionStorage = undefined;
        //this._sessionStorage = new UserGridData(`${this._gridKey}_explorerState`, null, { storageKey: 'deviceExplorer_explorerState', storageType: 'session' });
    }

    get columnConfig() {
        if (this.columns) {
            return this.columns;
        }
        this.columns = {
            name: {
                label: "Name",
                priority: 1,
            },
            description: {
                label: "Description",
                priority: 2,
            },
            permissionLevel: {
                label: "Permission Level",
                priority: 3,
                options: PERMISSION_LEVEL,
                columnRendererComponent: PermissionLevelColumn,
                shown: true,
            },
            lastAuditTime: {
                label: "Audited On",
                columnRendererComponent: DateColumn,
                priority: 4,
            },
            lastAuditBy: {
                label: "Audited By",
                width: 120,
                priority: 5,
            },
            lastAuditStatus: {
                label: "Audit Status",
                columnRendererComponent: AuditStatusColumn,
                width: 120,
                priority: 6,
                options: AUDIT_STATUSES,
            },
            lastAuditDeviceCount: {
                label: "Total Devices",
                width: 120,
                priority: 7,
            },
            lastAuditDeviceSuccessCount: {
                label: "Audited Devices",
                width: 120,
                priority: 8,
            },
            lastAuditDevicesNotInViolationCount: {
                label: "Passed Devices",
                width: 120,
                priority: 9,
            },
            lastAuditDevicesInViolationCount: {
                label: "Failed Devices",
                width: 120,
                priority: 10,
            },
            lastAuditDevicesSkippedCount: {
                label: "Skipped Devices",
                width: 120,
                priority: 11,
            },
            lastAuditDeviceErrorCount: {
                label: "Device Errors",
                width: 120,
                priority: 12,
            },
            lastAuditCriticalViolationCount: {
                label: "Critical Violations",
                width: 130,
                priority: 13,
            },
            lastAuditMajorViolationCount: {
                label: "Major Violations",
                width: 120,
                priority: 14,
            },
            lastAuditMinorViolationCount: {
                label: "Minor Violations",
                width: 120,
                priority: 15,
            },
            lastAuditInfoViolationCount: {
                label: "Informational Violations",
                width: 175,
                priority: 16,
            },
            lastAuditViolationCount: {
                label: "Total Violations",
                width: 120,
                priority: 17,
            },
            updatedOn: {
                label: "Updated On",
                columnRendererComponent: DateColumn,
                priority: 18,
            },
            updatedBy: {
                label: "Updated By",
                priority: 19,
            },
        };

        return this.columns;
    }

    get pagingFeed() {
        return this._pagingAuditFeed;
    }

    get selectedRows() {
        return this._renderer.selectedRows;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        // this._solutionsManager.on(
        //     "activeSolutionChanged",
        //     (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        // );
    }

    _unregisterListeners() {
        // this._solutionsManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
    }

    _patchSorting(sorting) {
        // add second sorting order by name
        if (
            sorting &&
            Object.keys(sorting).length === 1 &&
            !sorting.name &&
            this.columnConfig.name
        ) {
            sorting.name = 1;
        }
    }

    _registerFeedListeners() {}

    _unregisterFeedListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    whenModelIsReady() {
        return this._storageFactory
            .whenStorageIsReady()
            .then(() => {
                this._userGridData = this._storageFactory.getRemoteStorageInstanceForEntityGrid(
                    "entity_grid_gl",
                    this._gridKey
                );
                this._sessionStorage = this._storageFactory.getSessionStorageInstance(
                    "entity_grid_gl",
                    `${this._gridKey}_explorerState`
                );
                this._explorerState = Object.assign(
                    {},
                    this._explorerState,
                    this._sessionStorage.getData()
                );
            })
            .then(() => {
                this._pagingAuditFeed = new PagingAuditFeed({
                    feedKey: this._gridKey + "_feed",
                    userSession: this._userSession,
                    entityDef: this._configAuditPolicy,
                    columnConfig: this.columnConfig,
                    filter:
                        _.get(this._userGridData.getBasicSearchData(), "filterQuery", {}) ||
                        this._userGridData.getAdvancedSearchData(),
                    sort: this._userGridData.getSorting(),
                    additionalDataFields: ["permissionLevel"],
                });

                this._registerListeners();
                return Promise.resolve();
            })
            .then(() => {
                return this.whenFeedIsReady();
            });
    }

    wasFeedPreviouslyInitialized() {
        return this._pagingAuditFeed.wasPreviouslyInitialized();
    }

    whenFeedIsReady() {
        return this._pagingAuditFeed.whenFeedReady();
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterFeedListeners();
        this._unregisterListeners();
        let shutdowns = [
            _.isUndefined(this._renderer) ? Promise.resolve() : this._renderer.shutdown(),
            _.isUndefined(this._pagingAuditFeed)
                ? Promise.resolve()
                : this._pagingAuditFeed.shutdown(),
            _.isUndefined(this._sessionStorage)
                ? Promise.resolve()
                : this._sessionStorage.shutdown(),
        ];
        return Promise.all(shutdowns).then(
            () => {
                //this._gameEditor._unregisterDeviceExplorerListeners(); // Unregister game editor events
                // please avoid destroying parent components
                this._gameEditor = undefined;
                this._renderer = undefined;
                this._steveUtils = undefined;
                this._explorerState = undefined;
                this._pagingAuditFeed = undefined;
                this._userSession = undefined;
                this._modalUserFeedback = undefined;
                this._solutionsManager = undefined;
                this._solutionName = undefined;
                this._gridKey = undefined;
                this._userGridData = undefined;
                this._sessionStorage = undefined;
                this._logger = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "PolicyGridViewComponent.shutdown() error");
            }
        );
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get explorerState() {
        return this._explorerState;
    }

    set explorerState(val) {
        this.setExplorerState(val);
    }

    setExplorerState(val) {
        this._explorerState = val;
    }

    updateExplorerState(property, val) {
        this._sessionStorage.setData(val, property);
        _.set(this._explorerState, property, val);
    }

    resetSelection(newIds) {
        let selectedIds = [];

        if (newIds && newIds.length) {
            newIds.forEach((id) => {
                selectedIds.push(id);
            });
        }

        this.renderer._policyEntityGrid.setSelectedRows(selectedIds);
        this.updateExplorerState("selectedIds", {selectedRows: selectedIds});
        this.renderer._renderAvailableActions();
    }

    loadAndScrollTo(entityId) {
        let that = this;
        this.pagingFeed.on("RequestedEntityFound", handleRequestedEntityFound);
        this.pagingFeed._requestEntity(entityId);

        function handleRequestedEntityFound(index) {
            that.renderer._policyEntityGrid.renderer.scrollToTheRow(index);
            that.pagingFeed.removeListener("RefreshView", handleRequestedEntityFound);
        }
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    onUserSorted(sortData) {
        let sort = {};

        const sortCriteria =
            this.columnConfig[sortData.sortColumn].valuePath ||
            this.columnConfig[sortData.sortColumn].path ||
            sortData.sortColumn;

        sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        this._patchSorting(sort);

        this._pagingAuditFeed.setSort(sort);
    }

    _onSolutionChanged(solution) {
        // whole pane will be reset, no need to make any action here
        this._solutionName = solution.name;
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    openPolicyInstanceEditor(ids, fullyQualifiedViewName) {
        ids = [].concat(ids);

        const id = ids[0];
        let Policy = this._pagingAuditFeed.getPolicyEntityById(id);
        this._gameEditor.launchAuditEditor(
            {
                fqn: fullyQualifiedViewName || Registrations.AUDIT_POLICY_EDITOR_VIEW_DETAILS,
            },
            {
                id: id,
                title: _.get(Policy, "name", ""),
            }
        );
    }

    getSelectedPolicyIds() {
        return _.get(this._explorerState, "selectedIds", []);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = AuditPolicyGridViewComponent;

AuditPolicyGridViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.utils",
    "$teve.entities.ConfigAuditPolicy",
    "$teve.userSession",
    "$teve.storageFactory",
    "$teve.solutionsManager",
    "$teve.ui.userFeedback",
];

AuditPolicyGridViewComponent.$displayDetails = {
    type: "View",
    name: "",
    icon: "common.duplicate",
    shown: false,
    order: 1,
};
